import { callApi } from './ApiClient';

const postFollowCallAppointment = (timelineStatusId, data, dispatch) => {
  return callApi("POST", `/questionnaires/follow_call_appointment/${timelineStatusId}`, data, dispatch);
};

export const questionnaireApi = {
  postFollowCallAppointment,
};


// WEBPACK FOOTER //
// ./src/redux/api/QuestionnaireApi.js